import React, { useState } from "react";
import { I18nManager } from "react-native";
import { Provider } from "react-redux";
import { NavigationContainer } from "@react-navigation/native";
import getFonts from "./app/utils/fonts";
import AppLoading from "expo-app-loading";
import StackNavigator from "./app/containers/StackNavigator";
import { store } from "./app/store";

//* Support for RTL
I18nManager.allowRTL(true);
I18nManager.forceRTL(true);

const App = () => {
    const [fontLoading, setFontLoading] = useState(false);

    if (fontLoading) {
        return (
            <NavigationContainer>
                <Provider store={store}>
                    <StackNavigator />
                </Provider>
            </NavigationContainer>
        );
    } else {
        return (
            <AppLoading
                startAsync={getFonts}
                onFinish={() => setFontLoading(true)}
                onError={console.warn}
            />
        );
    }
};

export default App;
